<template>
  <div>
    <div v-if="item.description" v-html="markdown(item.description)"></div>
  </div>
</template>
<script>
import { markdown } from "@/lib/utilities";

export default {
  name: "sheet-notes-display",
  props: ["item"],
  methods: {
    markdown(value) {
      return markdown(value);
    }
  }
};
</script>
